import { useSelector } from 'react-redux';
import CustomToolTip from '../../CommonComponents/CustomToolTip';
import {
    BusObcSvg,
    ObcSvg,
    OSSvg,
    ADCSSvg,
    GPSSvg,
    ThrusterSvg,
    PayloadObcSvg,
    PayloadSSDSvg
} from '../Svgs/CatalogSvgs';

const BusSlider = ({
    selectedComp,
    setSelectedComp,
    enableBusSlider,
    blankTemplateData,
}) => {
    const CloneTemplate = useSelector((state: any) => state.catalog.CloneTemplate);
    //  Config array for all bus components
    const busItems = [
        {
            key: 'Bus OBC',
            type: 'Core',
            icon: <BusObcSvg />,
            path: ['assembly', 0, 'core', 'Bus OBC'],
        },
        {
            key: 'iADCS',
            type: 'Core',
            icon: <ADCSSvg />,
            path: ['assembly', 0, 'core', 'iADCS'],
        },
        {
            key: 'GPS',
            type: 'Core',
            icon: <GPSSvg />,
            path: ['assembly', 0, 'core', 'GPS'],
        },
        {
            key: 'Thruster',
            type: 'Core',
            icon: <ThrusterSvg />,
            path: ['assembly', 0, 'core', 'Thruster'],
        },
        {
            key: 'Payload OBC',
            type: 'Payload Server',
            icon: <PayloadObcSvg />,
            path: ['assembly', 0, 'payloadServer', 'Payload OBC'],
        },
        {
            key: 'Payload SSD',
            type: 'Payload Server',
            icon: <PayloadSSDSvg />,
            path: ['assembly', 0, 'payloadServer', 'Payload SSD'],
        },
    ];

    //  Safe nested getter
    const getNested = (obj: any, path: (string | number)[]) =>
        path.reduce((acc, key) => (acc ? acc[key] : undefined), obj);

    //  Render a single card
    const renderCard = ({ key, type, icon, path }: typeof busItems[0]) => {
        const updatedType = type === 'Payload Server' ? 'Payload' : type
        const countKey = key === 'Thruster' ? 'ThrusterCount' : 'Payload SSDCount'
        const cloneData = CloneTemplate[updatedType]?.[key];
        const blankData = getNested(blankTemplateData, [...path, "atmos-data"]);
        const numUnits = CloneTemplate[updatedType][countKey] || getNested(blankTemplateData, [...path, "user_data", "numUnits"]) || 0;
        const name = cloneData?.name || blankData?.name || "";
        const busOsName = CloneTemplate[type]?.['Bus OS']?.name || blankTemplateData?.['assembly']?.[0]?.['core']?.['Bus OS']?.['atmos-data']?.['name'] || ''
        return (
            <div
                key={key}
                className={`config-card ${selectedComp === key ? 'active' : ''}`}
                onClick={() => {
                    setSelectedComp(key);
                    enableBusSlider(cloneData || blankData || {}, key, type, numUnits);
                }}
            >
                <div className="w-100 d-flex align-item-center justify-content-between">
                    <h5 className="c-color1">{icon} {key === 'iADCS' ? 'ADCS' : key}</h5>
                </div>
                <div className="text-truncate d-flex align-items-center gap-2">
                    {(key === 'Bus OBC' && name) && <ObcSvg />}
                    <div className="w-95 text-truncate">
                        <CustomToolTip title={name} placement="top-start">{name}</CustomToolTip>
                    </div>
                    {(name && (key === 'Thruster' || key === 'Payload SSD')) && `(${numUnits})`}
                </div>
                {key === 'Bus OBC' && (
                    <div className="text-truncate d-flex align-items-center gap-2">
                        {busOsName && <OSSvg />}
                        <CustomToolTip title={busOsName} placement="top-start">{busOsName}</CustomToolTip>
                    </div>
                )}
            </div>
        );
    };

    return <div className="config-data-box h-100">{busItems.map(renderCard)}</div>;
};

export default BusSlider;
